import React from "react";
import DataTable from "react-data-table-component";
import dayjs from "dayjs";

const columns = [
  {
    name: "Source",
    selector: "source",
    sortable: true,
  },
  {
    name: "Metal",
    selector: "metal",
    sortable: true,
  },
  {
    name: "Sentiment",
    selector: "sentiment",
    sortable: true,
  },
  {
    name: "Timestamp",
    selector: "timestamp",
    sortable: true,
    right: true,
    cell: (row) => (
      <div>{dayjs(parseInt(row.timestamp)).format("YYYY-MM-DD HH:mm:ss")}</div>
    ),
  },
];

const ExpanableComponent = ({ data }) => {
  return (
    <div className="ml-5">
      <div>
        <small style={{ fontWeight: 700 }}>Text</small>
      </div>
      <small>{data.text}</small>
    </div>
  );
};
export default function RecordsTable({ title, data, ...props }) {
  if (data && data.length) {
    return (
      <DataTable
        title={title}
        striped={true}
        highlightOnHover={true}
        expandableRows={true}
        expandableRowsComponent={<ExpanableComponent />}
        columns={columns}
        data={data}
      />
    );
  } else {
    return null;
  }
}
